<main class="app-shell" *ngIf="data() as mapData; else loading">
  <aside class="sidebar" aria-label="Controles do mapa">
    <header class="brand">
      <div class="brand-row">
        <img src="awakenmap-icon.png" alt="" width="42" height="42">
        <div>
          <p class="kicker">Mapa de conexoes</p>
          <h1>AwakenMap</h1>
        </div>
      </div>
      <strong class="brand-theme">Great Awakening</strong>
      <p class="intro-copy">
        Explore conexoes entre consciencia, historia oculta, simbolos, civilizacoes antigas, tecnologia, espiritualidade e eventos globais.
      </p>
    </header>

    <label class="search-box">
      <span>Buscar</span>
      <input
        type="search"
        placeholder="Tema, camada ou conexao"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
      >
    </label>

    <section>
      <div class="section-title">Camadas tematicas</div>
      <div class="filter-list">
        <label class="filter-item" *ngFor="let category of mapData.categories">
          <input
            type="checkbox"
            [checked]="enabledCategories().has(category.id)"
            (change)="toggleCategory(category.id, $any($event.target).checked)"
          >
          <span>{{ category.name }}</span>
          <i class="swatch" [style.background]="category.color"></i>
        </label>
      </div>
    </section>

    <section>
      <div class="section-title">Caminhos guiados</div>
      <div class="trail-list">
        <button class="trail-button" type="button" *ngFor="let trail of mapData.trails" (click)="startTrail(trail)">
          {{ trail.title }}
        </button>
      </div>
    </section>

    <section class="stats" aria-live="polite">
      <div>
        <span>{{ visibleNodes().length }}</span>
            <small>pontos visiveis</small>
      </div>
      <div>
        <span>{{ renderedEdges().length }}</span>
            <small>ligacoes</small>
      </div>
    </section>
  </aside>

  <section class="map-stage" aria-label="Mapa interativo">
    <div class="topbar">
      <div>
        <strong>Mapa navegavel</strong>
        <span>{{ activeContext() }}</span>
      </div>
      <div class="mode-row" aria-label="Modo de visualizacao">
        <button type="button" [class.is-active]="mapMode() === 'explore'" (click)="setMode('explore')">Exploracao</button>
        <button type="button" [class.is-active]="mapMode() === 'total'" (click)="setMode('total')">Mapa total</button>
        <button *ngIf="mapMode() === 'total'" type="button" [class.is-active]="deepMode()" (click)="toggleDeepMode()">Profundo</button>
      </div>
      <div class="tool-row">
        <button type="button" title="Diminuir zoom" aria-label="Diminuir zoom" (click)="zoom(1.16)">-</button>
        <button type="button" title="Aumentar zoom" aria-label="Aumentar zoom" (click)="zoom(0.86)">+</button>
        <button type="button" title="Centralizar mapa" aria-label="Centralizar mapa" (click)="resetView()">[]</button>
      </div>
    </div>

    <div class="layer-row" aria-label="Camadas de visualizacao">
      <button
        type="button"
        *ngFor="let layer of layerOptions"
        [class.is-active]="activeLayer() === layer.id"
        (click)="setLayer(layer.id)"
      >
        {{ layer.label }}
      </button>
    </div>

    <svg
      #canvas
      id="mapCanvas"
      role="img"
      aria-label="Mapa de conexoes"
      [attr.viewBox]="viewBox().x + ' ' + viewBox().y + ' ' + viewBox().width + ' ' + viewBox().height"
      (pointerdown)="pointerDown($event)"
      (pointermove)="pointerMove($event)"
      (pointerup)="pointerUp($event)"
      (wheel)="wheel($event)"
    >
      <defs>
        <pattern id="grid" width="80" height="80" patternUnits="userSpaceOnUse">
          <path d="M 80 0 L 0 0 0 80" fill="none" stroke="rgba(255,255,255,0.06)" stroke-width="1"></path>
        </pattern>
      </defs>
      <rect x="-5000" y="-5000" width="10000" height="10000" fill="url(#grid)"></rect>

      <g class="islands" *ngIf="categoryIslands().length">
        <g
          class="island"
          *ngFor="let island of categoryIslands(); trackBy: trackIsland"
        >
          <ellipse
            [attr.cx]="island.x"
            [attr.cy]="island.y"
            [attr.rx]="island.rx"
            [attr.ry]="island.ry"
            [attr.fill]="island.color"
          ></ellipse>
          <text
            [attr.x]="island.x - island.rx + 48"
            [attr.y]="island.y - island.ry + 72"
          >
            {{ island.name }}
          </text>
        </g>
      </g>

      <ng-container *ngFor="let edge of renderedEdges(); trackBy: trackEdge">
        <path [attr.class]="edgeClass(edge)" [attr.d]="edgePath(edge)" [attr.stroke-width]="edge.strength + 1" fill="none"></path>
        <text
          *ngIf="shouldShowEdgeLabels()"
          class="edge-label"
          [attr.x]="edgeLabelPosition(edge).x"
          [attr.y]="edgeLabelPosition(edge).y"
          text-anchor="middle"
        >
          {{ edge.label }}
        </text>
      </ng-container>

      <g
        class="node"
        *ngFor="let node of visibleNodes(); trackBy: trackNode"
        [class.is-selected]="node.id === selectedNodeId()"
        [attr.transform]="'translate(' + node.position.x + ' ' + node.position.y + ')'"
        (pointerdown)="$event.stopPropagation()"
        (pointermove)="$event.stopPropagation()"
        (pointerup)="$event.stopPropagation()"
        (click)="$event.stopPropagation(); selectNode(node.id)"
      >
        <circle [attr.r]="nodeRadius(node)" [attr.fill]="categoryById(node.categoryId)?.color"></circle>
        <g class="node-icon" [ngSwitch]="iconKind(node)">
          <g *ngSwitchCase="'sun'" class="icon-sun">
            <circle r="11"></circle>
            <path d="M0 -22 L0 -15 M0 15 L0 22 M-22 0 L-15 0 M15 0 L22 0 M-15 -15 L-10 -10 M15 -15 L10 -10 M-15 15 L-10 10 M15 15 L10 10"></path>
          </g>
          <g *ngSwitchCase="'reptile'">
            <path d="M-18 0 Q0 -15 18 0 Q0 15 -18 0 Z"></path>
            <path d="M0 -10 L0 10"></path>
            <circle r="3"></circle>
          </g>
          <g *ngSwitchCase="'chip'">
            <rect x="-13" y="-13" width="26" height="26" rx="4"></rect>
            <path d="M-22 -8 L-13 -8 M-22 0 L-13 0 M-22 8 L-13 8 M13 -8 L22 -8 M13 0 L22 0 M13 8 L22 8 M-8 -22 L-8 -13 M0 -22 L0 -13 M8 -22 L8 -13 M-8 13 L-8 22 M0 13 L0 22 M8 13 L8 22"></path>
          </g>
          <g *ngSwitchCase="'book'">
            <path d="M-19 -16 H-3 Q0 -16 0 -12 V16 Q-4 12 -19 14 Z"></path>
            <path d="M19 -16 H3 Q0 -16 0 -12 V16 Q4 12 19 14 Z M-13 -7 H-5 M6 -7 H14"></path>
          </g>
          <g *ngSwitchCase="'coin'">
            <circle r="17"></circle>
            <path d="M0 -11 V11 M-8 -5 Q0 -12 8 -5 M-8 5 Q0 12 8 5"></path>
          </g>
          <g *ngSwitchCase="'portal'" class="icon-pulse">
            <circle r="18"></circle>
            <path d="M0 -18 C18 -8 18 8 0 18 C-18 8 -18 -8 0 -18 Z M-12 0 H12"></path>
          </g>
          <g *ngSwitchCase="'planet'">
            <circle r="13"></circle>
            <path d="M-24 4 C-11 -8 12 -8 24 4 M-22 7 C-8 17 10 17 22 7"></path>
          </g>
          <g *ngSwitchCase="'people'">
            <circle cx="-8" cy="-8" r="6"></circle>
            <circle cx="9" cy="-9" r="5"></circle>
            <path d="M-20 15 Q-8 2 4 15 M0 15 Q10 5 20 15"></path>
          </g>
          <g *ngSwitchCase="'drop'">
            <path d="M0 -21 C12 -5 18 4 18 12 C18 22 -18 22 -18 12 C-18 4 -12 -5 0 -21 Z"></path>
          </g>
          <g *ngSwitchCase="'shield'">
            <path d="M0 -21 L18 -13 V1 C18 12 10 19 0 23 C-10 19 -18 12 -18 1 V-13 Z"></path>
            <path d="M0 -13 V14"></path>
          </g>
          <g *ngSwitchCase="'gear'">
            <circle r="8"></circle>
            <path d="M0 -23 V-15 M0 15 V23 M-23 0 H-15 M15 0 H23 M-16 -16 L-11 -11 M16 -16 L11 -11 M-16 16 L-11 11 M16 16 L11 11"></path>
          </g>
          <g *ngSwitchCase="'hourglass'">
            <path d="M-14 -20 H14 M-14 20 H14 M-10 -18 C-10 -6 10 -6 10 0 C10 6 -10 6 -10 18 M10 -18 C10 -6 -10 -6 -10 0 C-10 6 10 6 10 18"></path>
          </g>
          <g *ngSwitchCase="'wave'">
            <path d="M-23 2 C-14 -12 -6 -12 0 2 C7 16 15 16 23 2"></path>
            <path d="M-23 13 C-14 -1 -6 -1 0 13 C7 27 15 27 23 13" transform="translate(0 -12)"></path>
          </g>
          <g *ngSwitchCase="'pin'">
            <path d="M0 22 C-13 6 -17 -1 -17 -9 C-17 -19 17 -19 17 -9 C17 -1 13 6 0 22 Z"></path>
            <circle r="6"></circle>
          </g>
          <g *ngSwitchCase="'person'">
            <circle cy="-11" r="8"></circle>
            <path d="M-17 20 Q0 2 17 20"></path>
          </g>
          <g *ngSwitchCase="'being'" class="icon-float">
            <path d="M0 -20 Q15 -8 15 6 Q8 20 0 20 Q-8 20 -15 6 Q-15 -8 0 -20 Z"></path>
            <path d="M-6 -2 H-2 M2 -2 H6 M-5 8 Q0 12 5 8"></path>
          </g>
          <g *ngSwitchCase="'leaf'">
            <path d="M-20 16 C-12 -16 10 -22 22 -20 C22 -3 11 17 -13 19 Z"></path>
            <path d="M-13 13 C-3 5 7 -3 18 -16"></path>
          </g>
          <g *ngSwitchCase="'ship'" class="icon-float">
            <path d="M-22 4 L0 -10 L22 4 L8 8 L0 14 L-8 8 Z"></path>
            <path d="M-6 2 L6 2 M-12 10 L-19 17 M12 10 L19 17"></path>
          </g>
          <g *ngSwitchCase="'mountain'">
            <path d="M-23 16 L-5 -16 L5 1 L12 -10 L24 16 Z"></path>
            <path d="M-5 -16 L-1 -4 L5 1"></path>
          </g>
          <g *ngSwitchCase="'lotus'" class="icon-pulse">
            <path d="M0 -20 C10 -8 10 8 0 18 C-10 8 -10 -8 0 -20 Z"></path>
            <path d="M-4 13 C-20 7 -21 -8 -8 -14 M4 13 C20 7 21 -8 8 -14"></path>
          </g>
          <g *ngSwitchCase="'bolt'">
            <path d="M4 -22 L-11 3 L2 3 L-4 22 L14 -5 L1 -5 Z"></path>
          </g>
          <g *ngSwitchCase="'eye'">
            <path d="M-22 0 Q0 -17 22 0 Q0 17 -22 0 Z"></path>
            <circle r="7"></circle>
          </g>
          <g *ngSwitchCase="'pyramid'">
            <path d="M-20 15 L0 -18 L20 15 Z"></path>
            <path d="M0 -18 L4 15 M-20 15 L20 15"></path>
          </g>
          <g *ngSwitchCase="'spark'" class="icon-pulse">
            <path d="M0 -22 L5 -5 L22 0 L5 5 L0 22 L-5 5 L-22 0 L-5 -5 Z"></path>
          </g>
          <g *ngSwitchDefault>
            <circle r="10"></circle>
            <path d="M-16 0 L16 0 M0 -16 L0 16"></path>
          </g>
        </g>
        <text *ngIf="shouldShowNodeLabel(node)" x="0" [attr.y]="nodeRadius(node) + 22" text-anchor="middle">{{ node.title }}</text>
      </g>
    </svg>
  </section>

  <aside class="detail-panel" aria-label="Resumo do assunto selecionado" *ngIf="activeDetailNode() as node">
    <button class="close-detail" type="button" aria-label="Fechar resumo" (click)="closeDetail()">x</button>
    <p class="kicker">Resumo da teoria</p>
    <h2>{{ node.title }}</h2>
    <p class="original-name" *ngIf="node.titleOriginal && node.titleOriginal !== node.title">
      Nome no poster: {{ node.titleOriginal }}
    </p>
    <p>{{ node.summary }}</p>

    <div class="detail-meta">
      <span class="pill">{{ categoryById(node.categoryId)?.name }}</span>
      <span class="pill">{{ node.type }}</span>
      <span class="pill">importancia {{ node.importance }}/5</span>
    </div>

    <a class="learn-more" [href]="'/conteudo/' + node.slug + '/'">Saiba mais</a>

    <div class="section-title">Conexoes proximas</div>
    <button class="expand-button" type="button" (click)="toggleExpandedConnections()">
      {{ expandedConnections() ? 'Ocultar secundarias' : 'Expandir secundarias' }}
    </button>
    <div class="related-list">
      <button
        class="related-item"
        type="button"
        *ngFor="let edge of relatedEdges()"
        (click)="relatedNode(edge) && selectNode(relatedNode(edge)!.id)"
      >
        {{ edge.label }}: {{ relatedNode(edge)?.title }}
      </button>
    </div>
  </aside>
</main>

<ng-template #loading>
  <main class="loading-state">Carregando mapa...</main>
</ng-template>
